// extracted by mini-css-extract-plugin
export default {"root":"skeleton_root__LGTBV","heading":"skeleton_heading__sfCBW","item":"skeleton_item__9Zi7N","animatable":"skeleton_animatable__xb-u+","animate":"skeleton_animate__BlW1p"};